import { useEffect, useState } from "react";

import { Center } from "@chakra-ui/react";
import unixTimeToDateTime from "../../utils/unixTimeToDateTime";
import { ServerStatus } from "../../utils/interfaces";


interface ServerClockParams {
  serverStatus: ServerStatus;
}

/**
 * Una caja que muestra la fecha y hora del servidor.
 * 
 * @param {ServerClockParams} Un objeto que contiene el estado del servidor.
 * @returns {JSX.Element}
 */
export default function ServerClock({ serverStatus }: ServerClockParams): JSX.Element {
  const [updatedServerUnixTime, setUpdatedServerUnixTime] = useState(serverStatus.unixTime);

  useEffect(() => {
    const interval = setInterval(() => {
      if (serverStatus.hasError) {
        setUpdatedServerUnixTime(serverStatus.unixTime);
      } else {
        setUpdatedServerUnixTime(updatedServerUnixTime + 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  });

  useEffect(() => {
    setUpdatedServerUnixTime(serverStatus.unixTime);
  }, [serverStatus.unixTime]);

  /**
   * Obtiene la hora actual del servidor en formato string.
   * 
   * @returns {string} El string de la hora actual.
   */
  const getCurrentTime = (): string => {
    if (serverStatus.isLoading || updatedServerUnixTime === 0) {
      return "";
    }
    return unixTimeToDateTime(updatedServerUnixTime);
  };

  return (
    <Center
      px="2"
      py="2"
      borderRadius="md"
      bg={serverStatus.isLoading ? "blue.300" : serverStatus.hasError ? "red.300" : "green.300"}
      color={serverStatus.isLoading ? "blue.800" : serverStatus.hasError ? "red.800" : "green.800"}
    >
      <p>
        <b>{serverStatus.isLoading ? "Cargando..." : serverStatus.hasError ? "¡Error! " : "¡OK! "}</b> {getCurrentTime()}
      </p>
    </Center>
  );
}